// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1RiAJ","alertIcon":"ConfirmModal_alertIcon__2sYIb"};